
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class BatchFilterCandidate extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: () => [] }) defaultList!: string[];

  inputValue = "";
  errorList: string[] = [];
  successList: string[] = [];
  showRemoveConfirm = false;
  invalidCodesMap: Map<string, string> = new Map();

  @Watch("visible", { immediate: true })
  handleVisibleChange() {
    if (this.defaultList.length) {
      this.inputValue = this.defaultList.join("\n");
    } else {
      this.inputValue = "";
    }
    this.validateInput();
  }

  validateInput() {
    const lines = this.inputValue
      .split(/\r?\n/)
      .map(l => l.trim())
      .filter(l => l);
    const set = new Set<string>();
    this.errorList = [];
    this.successList = [];
    this.invalidCodesMap.clear();

    lines.forEach((code, idx) => {
      if (set.has(code)) {
        this.errorList.push(`${code} 重复`);
        this.invalidCodesMap.set(code, `${code} 重复`);
      } else if (!/^\d{11}$/.test(code)) {
        if (!/^\d+$/.test(code)) {
          this.errorList.push(`${code} 非数字`);
          this.invalidCodesMap.set(code, `${code} 非数字`);
        } else if (!/^[52]\d{10}$/.test(code)) {
          this.errorList.push(`${code} 不是5开头或2开头的11位数字`);
          this.invalidCodesMap.set(code, `${code} 不是5开头或2开头的11位数字`);
        } else {
          this.errorList.push(`${code} 非11位`);
          this.invalidCodesMap.set(code, `${code} 非11位`);
        }
      } else if (!/^[52]\d{10}$/.test(code)) {
        this.errorList.push(`${code} 不是5开头或2开头的11位数字`);
        this.invalidCodesMap.set(code, `${code} 不是5开头或2开头的11位数字`);
      } else {
        set.add(code);
        this.successList.push(code);
      }
    });
  }

  handleClose() {
    this.$emit("update:visible", false);
    this.errorList = [];
    this.successList = [];
  }

  clearInput() {
    this.inputValue = "";
    this.errorList = [];
    this.successList = [];
    this.$emit("confirm", this.successList);
  }

  handleConfirm() {
    this.$emit("confirm", this.successList);
    this.handleClose();
  }

  showRemoveInvalidConfirm() {
    this.showRemoveConfirm = true;
  }

  removeInvalidCodes() {
    // 获取原始行，保留空行和格式
    const originalLines = this.inputValue.split(/\r?\n/);

    // 用于跟踪已处理的有效链接码
    const processedValidCodes = new Set<string>();

    // 过滤掉无效的链接码，对于重复的链接码保留第一次出现的
    const filteredLines = originalLines
      .map(line => {
        const trimmedLine = line.trim();

        // 如果是空行，直接保留
        if (!trimmedLine) {
          return line;
        }

        // 检查是否是无效链接码
        const errorMsg = this.invalidCodesMap.get(trimmedLine);

        // 如果不是无效链接码，或者是重复的链接码但第一次出现
        if (!errorMsg) {
          return line;
        }

        // 如果是重复错误，并且是第一次出现的有效链接码
        if (
          errorMsg.includes("重复") &&
          !processedValidCodes.has(trimmedLine)
        ) {
          // 标记为已处理过的有效链接码
          processedValidCodes.add(trimmedLine);
          return line;
        }

        // 其他情况（非重复的无效链接码或重复出现的有效链接码）
        return "";
      })
      .filter(line => line.trim() !== ""); // 过滤掉空行

    // 更新输入值
    this.inputValue = filteredLines.join("\n");

    // 关闭确认弹框
    this.showRemoveConfirm = false;

    // 重新验证
    this.validateInput();
  }
}
